module.exports = __webpack_public_path__ + "static/media/Create_banner_vertical.a34ab44b.png";